import { useTranslate } from "@refinedev/core";
import {
  Authenticated,
  CanAccess,
  useCustomMutation,
  useShow,
} from "@refinedev/core";
import { useParams } from "react-router-dom";
import { MediaStatus } from "../components/MediaStatusComponent";
import { Button, Flex, Typography } from "antd";
import { DateField, Show } from "@refinedev/antd";
import { useRef, useState } from "react";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";

import { Organization } from "types";
import { MediaDocument, Message } from "../types";
import { useAntTheme } from "hooks/useAntTheme";
import { BuildOutlined } from "@ant-design/icons";
import { Chat } from "../components/chat/Chat";
import { addDateTz } from "../utils";
import { PdfViewer } from "components/PdfViewer";

export const MediaDocumentDetail = ({
  organization,
}: {
  organization?: Organization;
}) => {
  const t = useTranslate();
  const params = useParams();
  const id = params?.id;
  const { theme } = useAntTheme();
  const [prompt, setPrompt] = useState("");
  const [promptIsLoading, setPromptIsLoading] = useState(false);
  const messages = useRef<Array<Message>>([]);

  const { queryResult } = useShow<MediaDocument>({
    resource: `media/documents/${organization?.id}`,
    id,
    queryOptions: {
      enabled: !!organization,
    },
  });
  const { isLoading } = queryResult;
  const { data: document } = queryResult.data || {};

  const { mutate: mutatePrompt } = useCustomMutation<{
    id: string;
    promptId: string;
    completion: string;
  }>();

  const { mutate: mutateReindex, isLoading: reindexIsLoading } =
    useCustomMutation();

  const handlePromptChange = (prompt: string) => {
    const promptId = new Date().toISOString();
    messages.current.push({ id: promptId, prompt });
    setPromptIsLoading(true);
    mutatePrompt(
      {
        url: `media/documents/${organization?.id}/${id}/query`,
        method: "post",
        values: {
          prompt,
          id: promptId,
        },
      },
      {
        onError: (error, variables, context) => {
          // An error occurred!
          setPromptIsLoading(false);
        },
        onSuccess: (data, variables, context) => {
          messages.current.push(data.data);
          setPromptIsLoading(false);
        },
      }
    );
  };

  const handleReindexClick = () => {
    if (document?.id && organization) {
      mutateReindex({
        url: `media/documents/${organization.id}/${document.id}/reindexing`,
        method: "post",
        values: {},
      });
    }
  };
  const headerButtons = [
    <CanAccess resource="media_documents" action="document_index">
      <Button
        key="reindex"
        loading={reindexIsLoading}
        onClick={handleReindexClick}
        icon={<BuildOutlined />}
      >
        {t("media.documents.detail.reindex")}
      </Button>
    </CanAccess>,
  ];
  return (
    <Authenticated key="documentDetail">
      <div style={{ position: "relative" }}>
        <Show
          title={document?.name}
          isLoading={isLoading}
          headerButtons={headerButtons}
        >
          <Flex style={{ marginBottom: 30 }}>
            {document?.status && <MediaStatus status={document?.status} />}
            <Typography.Text>
              {t("media.documents.detail.createdAt")}
              <DateField value={addDateTz(document?.created)} />
            </Typography.Text>
          </Flex>
          {/* <Row>
        <Col span={24}>
          <Typography.Text>
            ID : <Typography.Text code>{document?.id}</Typography.Text>
          </Typography.Text>
        </Col>
      </Row> */}

          <Flex vertical>
            <PanelGroup autoSaveId="example" direction="horizontal">
              <Panel defaultSize={40} minSize={20}>
                {document?.url && <PdfViewer url={document?.url} />}
              </Panel>
              <PanelResizeHandle
                style={{
                  width: 4,
                  background: `${theme.colorPrimary}30`,
                  borderRadius: 10,
                  marginLeft: 10,
                }}
              />
              <Panel defaultSize={60} minSize={20} style={{ paddingLeft: 10 }}>
                {document?.id && organization?.id && (
                  <Chat
                    documentIds={[document?.id]}
                    organizationId={organization?.id}
                  />
                )}
                {/* <div
          style={{
            overflowY: "auto",
            height: "calc(100vh - 300px)",
            paddingLeft: 10,
            paddingRight: 10,
          }}
        >
          <DocumentSummaries document={document as Document} />
          <PromptHistory
            messages={messages.current}
            setPrompt={setPrompt}
          />
        </div> */}
              </Panel>
            </PanelGroup>
          </Flex>
        </Show>
        {/* <PromptForm
          disabled={isLoadingCompletion}
          onChange={handlePromptChange}
          value={prompt}
          style={{
            position: "fixed",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            // right: 0,
            maxWidth: 800,
            width: "calc(50vw)",
            // width: "calc(100% - 250px)", // remove sidebar width TODO improve
          }}
        /> */}
      </div>
    </Authenticated>
  );
};
